import { Link } from 'react-router-dom';

const Footer = () => {
  const links = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <footer style={{ background: '#1A1A1A', borderTop: '3px solid #F5C300' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '3rem 1.5rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2.5rem', marginBottom: '2.5rem' }}>

          {/* Logo + Tagline */}
          <div>
            <Link to="/" style={{ textDecoration: 'none', display: 'inline-block', marginBottom: '1rem' }}>
              <div style={{ fontFamily: '"Barlow Condensed", sans-serif', color: '#F5C300', fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.08em', lineHeight: 1 }}>
                NORTH CITY
              </div>
              <div style={{ fontFamily: '"Barlow Condensed", sans-serif', color: '#ffffff', fontWeight: 600, fontSize: '0.7rem', letterSpacing: '0.18em', marginTop: '2px' }}>
                SERVICE &amp; TYRE CENTRE
              </div>
            </Link>
            <p style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.55)', fontSize: '0.85rem', lineHeight: 1.6, maxWidth: '240px' }}>
              Family owned, MTA assured automotive workshop proudly serving Porirua and surrounding communities.
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <h4 style={{ fontFamily: '"Barlow Condensed", sans-serif', color: '#F5C300', fontWeight: 700, fontSize: '1rem', letterSpacing: '0.1em', marginBottom: '1rem', marginTop: 0 }}>
              QUICK LINKS
            </h4>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {links.map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.65)', fontSize: '0.875rem', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => { e.target.style.color = '#F5C300'; }}
                  onMouseLeave={e => { e.target.style.color = 'rgba(255,255,255,0.65)'; }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Details */}
          <div>
            <h4 style={{ fontFamily: '"Barlow Condensed", sans-serif', color: '#F5C300', fontWeight: 700, fontSize: '1rem', letterSpacing: '0.1em', marginBottom: '1rem', marginTop: 0 }}>
              CONTACT
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
              {[
                { label: 'Address', value: '12 Wall Place, Kenepuru, Porirua 5022' },
                { label: 'Phone', value: '0210 812 1239' },
                { label: 'Email', value: 'sales@northcitytyres.co.nz' },
                { label: 'Hours', value: 'Mon to Thu: 8:00am to 5:00pm' },
                { label: '', value: 'Fri: 8:00am to 4:30pm' },
                { label: '', value: 'Sat: 8:30am to 1:00pm' },
                { label: '', value: 'Sun: Closed' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', gap: '0.5rem' }}>
                  {item.label && (
                    <span style={{ fontFamily: 'Inter, sans-serif', color: '#F5C300', fontSize: '0.8rem', fontWeight: 600, minWidth: '52px' }}>
                      {item.label}:
                    </span>
                  )}
                  <span style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.65)', fontSize: '0.85rem', marginLeft: item.label ? 0 : '60px' }}>
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Social Links (placeholder) */}
          <div>
            <h4 style={{ fontFamily: '"Barlow Condensed", sans-serif', color: '#F5C300', fontWeight: 700, fontSize: '1rem', letterSpacing: '0.1em', marginBottom: '1rem', marginTop: 0 }}>
              FOLLOW US
            </h4>
            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              {['Facebook', 'Instagram'].map(platform => (
                <a
                  key={platform}
                  href="#social"
                  style={{
                    fontFamily: 'Inter, sans-serif', fontSize: '0.8rem', color: 'rgba(255,255,255,0.65)',
                    border: '1px solid rgba(255,255,255,0.2)', padding: '0.4rem 0.9rem',
                    borderRadius: '9999px', textDecoration: 'none', transition: 'all 0.2s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#F5C300'; e.currentTarget.style.color = '#F5C300'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}
                  onClick={e => e.preventDefault()}
                >
                  {platform}
                </a>
              ))}
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <Link
                to="/contact"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                  background: '#F5C300', color: '#1A1A1A',
                  fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 700,
                  fontSize: '0.875rem', letterSpacing: '0.08em',
                  padding: '0.6rem 1.25rem', borderRadius: '9999px', textDecoration: 'none',
                  transition: 'background 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#e6b800'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#F5C300'; }}
              >
                BOOK NOW
                <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1.5rem', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '0.5rem' }}>
          <p style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem', margin: 0 }}>
            &copy; {new Date().getFullYear()} North City Service and Tyre Centre. All rights reserved.
          </p>
          <p style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem', margin: 0 }}>
            MTA Assured Workshop | Porirua, New Zealand
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
